import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useLabTestListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const [labTestList, setLabTestList] = useState<any | []>();

  const configuration = useConfiguration();
  const execute = useCallback(
    async (labPartnerId: string) => {
      dispatch(setLoading({ key: "isLabTestListInProgress", status: true }));
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${LAB_REPORT?.LAB_TEST_LIST?.baseURL}${labPartnerId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              setLabTestList(res.data.data);
            } else {
              setLabTestList([]);
            }
            dispatch(setLoading({ key: "isLabTestListInProgress", status: false }));
          })
          .catch((e: AxiosError) => {
            setLabTestList([]);
            dispatch(setLoading({ key: "isLabTestListInProgress", status: false }));
            sendCurl(e.config["curlCommand"]);
          });
      } catch (e: any) {
        setLabTestList([]);
        dispatch(setLoading({ key: "isLabTestListInProgress", status: false }));
      }
    },
    [dispatch],
  );
  return { execute, labTestList };
};
